import { isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { isNil } from 'lodash';

import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('validatePhone');

export const SUPPORTED_COUNTRIES = ['GB', 'US', 'AE'];

// IANA timezone names → country code (US, GB, AE). Covers US zones, UK, and UAE.
export const TIMEZONE_TO_COUNTRY_CODE_MAP = {
  // UK
  'Europe/London': 'GB',
  // UAE
  'Asia/Dubai': 'AE',
  // US — continental, Alaska, Hawaii, territories
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'America/Phoenix': 'US',
  'America/Anchorage': 'US',
  'America/Boise': 'US',
  'America/Detroit': 'US',
  'America/Adak': 'US',
  'America/Juneau': 'US',
  'America/Sitka': 'US',
  'America/Metlakatla': 'US',
  'America/Nome': 'US',
  'America/Yakutat': 'US',
  'America/Indiana/Indianapolis': 'US',
  'America/Indiana/Knox': 'US',
  'America/Indiana/Marengo': 'US',
  'America/Indiana/Petersburg': 'US',
  'America/Indiana/Tell_City': 'US',
  'America/Indiana/Vevay': 'US',
  'America/Indiana/Vincennes': 'US',
  'America/Indiana/Winamac': 'US',
  'America/Kentucky/Louisville': 'US',
  'America/Kentucky/Monticello': 'US',
  'America/North_Dakota/Beulah': 'US',
  'America/North_Dakota/Center': 'US',
  'America/North_Dakota/New_Salem': 'US',
  'America/Menominee': 'US',
  'America/Puerto_Rico': 'US',
  'America/Virgin': 'US',
  'America/St_Thomas': 'US',
  'Pacific/Honolulu': 'US',
  'Pacific/Guam': 'US',
  'Pacific/Midway': 'US',
};

export const validatePhone = withOptions(({ value, countryCode }) => {
  if (isNil(value)) return null;

  if (value === '' || typeof value !== 'string') {
    L.warn('validatePhone()', 'Invalid value:', value);
    return false;
  }

  try {
    const newValue = fromAnyToSpacelessString(value);

    const phoneInfo = parsePhoneNumber(newValue, countryCode);

    const phoneCountryCode = phoneInfo?.country;

    if (!SUPPORTED_COUNTRIES.includes(phoneCountryCode)) {
      L.warn('validatePhone()', 'Unsupported country code:', phoneCountryCode);
      return false;
    }

    const isPossibleNumber = isPossiblePhoneNumber(phoneInfo?.number);

    return isPossibleNumber;
  } catch (error) {
    if (error instanceof TypeError) {
      return false;
    }
    throw error;
  }
});
